import Main from './Main'
import Lista from './components/Representante'
import Novo from './components/NovoRepresentante'

export default [
  {
    path: 'pc-reintegrador-representante',
    name: 'policiacivil.processo.reintegrador-representante',
    component: Main,
    redirect: { name: 'policiacivil.processo.reintegrador-representante.list' },
    children: [
      {
        path: '/',
        name: 'policiacivil.processo.reintegrador-representante.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'policiacivil.processo.reintegrador-representante.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'policiacivil.processo.reintegrador-representante.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/policia-civil/processo/reintegrador/representante/routes.js